import {combineLatest} from 'rxjs';
import {filter, map, startWith} from 'rxjs/operators';
import {currenciesCurrencyCache$} from '@/config';
import {fiat$} from '@/state/fiat';
import {indexPricesCache$} from '@/price-index/price-index';
import {launchPoolAccounts$} from '@/launch-pool-accounts/launchpool-accounts';
import {calcTotalAssets} from '@/assets/calc';
import type {AssetEntity, Assets} from '@/types';
import {numUtil, plus} from '@/helper/num';

export const launchPoolAssets$ = launchPoolAccounts$.pipe(
  map((launchPoolAccounts) =>
    launchPoolAccounts.map(
      (account): AssetEntity => ({currency: account.investCurrency, valueEv: account.investAmountEv})
    )
  ),
  startWith([])
);

const launchPoolAssets2$ = combineLatest([launchPoolAccounts$, currenciesCurrencyCache$]).pipe(
  map(([launchPoolAccounts, currenciesCurrencyCache]) =>
    launchPoolAccounts.map((account): AssetEntity => {
      const currencyInfo = currenciesCurrencyCache.get(account.investCurrency);
      return {
        currency: account.investCurrency,
        valueEv: plus(account.investAmountEv, numUtil.floor(account.stakingBalanceRv, 0, -currencyInfo.valueScale)),
      };
    })
  ),
  startWith([])
);

export const launchPoolTotalAssets$ = combineLatest([
  launchPoolAssets$,
  launchPoolAssets2$,
  indexPricesCache$,
  currenciesCurrencyCache$,
  fiat$,
]).pipe(
  map(([launchPoolAssets, launchPoolExpandAssets, indexPricesCache, currencies, fiat]) => {
    const assets = calcTotalAssets(launchPoolAssets, indexPricesCache, currencies, fiat);
    if (!assets) {
      return null;
    }
    const expandAssets = calcTotalAssets(launchPoolExpandAssets, indexPricesCache, currencies, fiat);
    return {
      ...assets,
      expand: expandAssets,
    };
  }),
  filter<Assets & {expand; Assets}>(Boolean)
);
